import { render, staticRenderFns } from "./AddDriverModal.vue?vue&type=template&id=0583223c"
import script from "./AddDriverModal.vue?vue&type=script&lang=ts"
export * from "./AddDriverModal.vue?vue&type=script&lang=ts"
import style0 from "./AddDriverModal.vue?vue&type=style&index=0&id=0583223c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports